import React from 'react';
import { Col } from 'antd';
const BraintreeHostedField = ({ id, label, className }) => (React.createElement("div", { className: className },
    React.createElement(Col, { xs: 24, id: label },
        React.createElement("label", { className: "form__label", htmlFor: id }, label),
        React.createElement("div", { id: id, className: "form__input" }))));
export { BraintreeHostedField };
